import { render, staticRenderFns } from "./TextareaWithMentions.vue?vue&type=template&id=758935b9"
import script from "./TextareaWithMentions.vue?vue&type=script&lang=js"
export * from "./TextareaWithMentions.vue?vue&type=script&lang=js"
import style0 from "./TextareaWithMentions.vue?vue&type=style&index=0&id=758935b9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('758935b9')) {
      api.createRecord('758935b9', component.options)
    } else {
      api.reload('758935b9', component.options)
    }
    module.hot.accept("./TextareaWithMentions.vue?vue&type=template&id=758935b9", function () {
      api.rerender('758935b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/TextareaWithMentions.vue"
export default component.exports